<img [src]="imgSrc" alt="" [ngClass]=" isSize === 'big' ? 'w-104 h-128 rounded-sm opacity-75' : 'w-56 h-56 rounded-sm shadow'" />
